export default __webpack_public_path__ + "static/media/herobanner-062022.cd0c8e69.jpg";